
export default {
  name: 'Tag',

  props: {
    text: String,
    icon: {
      type: String,
      default: ''
    },
    check: {
      type: Boolean,
      default: false
    }
  }
}
